import * as React from 'react'
import './news-list.css'

export default class NewsList extends React.Component<any> {
  constructor(props: any) {
    super(props)
    this.state = {}
  }

  render() {
    const content = this.props.content?.sort((a: any, b: any) =>
      a.fields.order > b.fields.order
        ? 1
        : b.fields.order > a.fields.order
        ? -1
        : 0,
    )

    return (
      <div className="news-list-overview">
        <div className="item-container">
          <h2>Við mælum með</h2>
        </div>
        <div className="news-list item-container">
          {content !== undefined &&
            Object.keys(content).map(key => {
              const correctClassName =
                parseInt(key, 10) !== content.length - 1
                  ? 'news-list-item items-3 item-gutter'
                  : 'news-list-item items-3'
              const image = {
                backgroundImage: `url(${content[key].fields.mynd.fields.file.url})`,
              }
              return (
                <div key={key} className={correctClassName}>
                  <a href={content[key].fields.link} className={'no-underline'}>
                    <div className="news-list-image" style={image} />
                    <div className="news-list-item-title">
                      <strong>{content[key].fields.textiBold}</strong>
                      <span> - {content[key].fields.texti}</span>
                    </div>
                  </a>
                </div>
              )
            })}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/front-page/news-list/news-list.tsx